import React from 'react';

const IconZap = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512.001 512.001"
    enableBackground="new 0 0 512.001 512.001">
    <path
      fill="#64ffda"
      d="m 256,350.31578 c -141.44,0 -256,48.23579 -256,107.78952 V 512 H 512 V 458.1053 C 512,398.55157 397.44,350.31578 256,350.31578 M 128,188.63158 a 128,107.78947 0 0 0 128,107.7895 128,107.78947 0 0 0 128,-107.7895 M 240,0 c -9.6,0 -16,5.658947 -16,13.473684 v 80.84211 H 192 V 26.947373 c 0,0 -72,23.174735 -72,101.052627 0,0 -24,3.77263 -24,33.68421 H 416 C 414.4,131.77263 392,128 392,128 392,50.122108 320,26.947373 320,26.947373 V 94.315794 H 288 V 13.473684 C 288,5.658947 281.92,0 272,0 Z"
    />
  </svg>
);

export default IconZap;
